// In Chakra UI v3, Text does not have a theme recipe.
// Text variants (labelXs, badgeSm, etc.) are registered as textStyles in src/theme/index.ts.
// Use the `textStyle` prop on any component instead of `variant`.
export const calloutGradient = {
  background: 'linear-gradient(90deg, #d97258 0%, #9858a3 100%)',
  backgroundClip: 'text',
  filter: 'drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.5))',
}
